import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../lib/api";

/** 完了済み TODO を一括削除するミューテーションフック */
export const useDeleteCompletedTodos = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (labelId: string) => {
      const res = await api.completed.$delete({
        query: { labelId },
      });
      if (!res.ok) throw new Error("Failed to delete completed todos");
      const json = await res.json();
      return json.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["todos"] });
      toast.success(`完了済み ${data.count} 件を削除しました`);
    },
    onError: (err) => {
      toast.error("削除に失敗しました");
    },
  });
};
